import BApp from "../../modules/BApp";
import BRequest from "../../modules/BRequest";

export default class BDrugs
{
	constructor(el)
	{
		this.el = el;
	}

	static selector = () => `.profile-drug-table-container`;

	static initialize()
	{
		this.addEventListeners();
	}

	static addEventListeners()
	{
		document.addEventListener("click", event => {
			const selector = `.profile-drug-entry__delete-button`;
			if (event.target.matches(`${selector}, ${selector} *`)) {
				const buttonEl = event.target.closest(selector);
				const entryEl = buttonEl.closest(`.profile-entry`);
				const url = buttonEl.dataset.url;
				const data = {
					objectId: parseInt(buttonEl.closest(`[data-id]`).dataset.id),
				};

				entryEl.remove();

				BRequest.delete(url, data).then(response => {
					const drugs = new this(document.querySelector(this.selector()));
					drugs.setHtml(response.data.templates.table);
				}).finally(() => {
					BApp.refresh();
				})
			}
		});
	}

	setHtml(html)
	{
		this.el.innerHTML = html;
	}
}
